import React, { useMemo } from "react";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import { Image } from "antd";
import {CDN_URL} from "../config";

const mjConfig = {
    loader: { load: ["[tex]/ams"] },
    tex: {
        packages: { "[+]": ["ams"] },
        inlineMath: [["$", "$"], ["\\(", "\\)"]],
        displayMath: [["$$", "$$"], ["\\[", "\\]"]],
        processEscapes: true,
    },
    options: {
        skipHtmlTags: ["script", "noscript", "style", "textarea", "pre", "code"],
    },
};

const splitter = /(\$\$[\s\S]*?\$\$|\$(?:\\\$|[^$])+\$)/g;
const imageRegex = /\\includegraphics\[.*?width\s*=\s*([\d.]+)\\textwidth.*?\]\{(.+?)\}/;

function parseTextWithMath(text, { isMobile, cdnBase }) {
    if (!text) return null;
    const lines = text.split("\n");

    return lines.map((line, lineIndex) => {
        const parts = line.split(splitter);

        return (
            <div key={`l-${lineIndex}`}>
                {parts.map((part, index) => {
                    if (!part) return <React.Fragment key={`e-${lineIndex}-${index}`} />;

                    if (part.startsWith("$$") && part.endsWith("$$")) {
                        const content = part.slice(2, -2).trim();
                        return (
                            <MathJax key={`d-${lineIndex}-${index}`} dynamic hideUntilTypeset="every">
                                {`\\[${content}\\]`}
                            </MathJax>
                        );
                    }

                    if (part.startsWith("$") && part.endsWith("$")) {
                        const content = part.slice(1, -1).trim();
                        const match = content.match(imageRegex);

                        if (match) {
                            const widthPercent = Math.min(100, Math.max(1, parseFloat(match[1]) * 100 || 100));
                            const imageName = match[2].trim();
                            // const imageUrl = cdnBase ? `${CDN_URL}/cdn/${imageName}` : imageName;
                            const imageUrl = `${CDN_URL}/tester/${imageName}`;
                            return (
                                <Image
                                    key={`img-${lineIndex}-${index}`}
                                    src={imageUrl}
                                    alt={imageName}
                                    style={{ width: isMobile ? "100%" : `${widthPercent}%`, margin: "10px 0" }}
                                />
                            );
                        }

                        return (
                            <MathJax key={`i-${lineIndex}-${index}`} inline dynamic hideUntilTypeset="every">
                                {`\\(${content}\\)`}
                            </MathJax>
                        );
                    }

                    return <React.Fragment key={`t-${lineIndex}-${index}`}>{part}</React.Fragment>;
                })}
            </div>
        );
    });
}

export default function MathText({
                                     text,
                                     value,
                                     isMobile = false,
                                     cdnBase = "",
                                     mathjaxVersionParam,
                                 }) {
    const src =
        "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js" +
        (mathjaxVersionParam ? `?v=${mathjaxVersionParam}` : "");

    const nodes = useMemo(
        () => parseTextWithMath(text ?? value, { isMobile, cdnBase }),
        [text, value, isMobile, cdnBase]
    );

    return (
        <MathJaxContext version={3} config={mjConfig} src={src}>
            <div className="math-text">{nodes}</div>
        </MathJaxContext>
    );
}
